import { z } from 'zod';
import { agencyTaskSchema } from '../agency-tasks/list';

// Order matches the display order used by the /v1/tasks endpoint when
// grouping by date (delayed first, completed last).
export const TASK_DATE_BUCKETS = [
  'delayed',
  'today',
  'thisWeek',
  'nextWeek',
  'upcoming',
  'completed',
] as const;

export const taskDateBucketSchema = z.enum(TASK_DATE_BUCKETS);

export type TaskDateBucket = z.infer<typeof taskDateBucketSchema>;

export const TASK_SORT_BY_VALUES = ['dueDate', 'priority'] as const;

export const taskSortBySchema = z.enum(TASK_SORT_BY_VALUES);

export type TaskSortBy = z.infer<typeof taskSortBySchema>;

export const filteredUserTaskSchema = agencyTaskSchema.extend({
  isBlocked: z.boolean().optional(),
  dependencyLastUnblockedAt: z.coerce.date().nullable().optional(),
  // Computed server-side from dueDate/post.date/completedAt relative to the
  // current date — present whenever the /v1/tasks endpoint returns the task.
  dateBucket: taskDateBucketSchema.optional(),
  // Effective client name for this task: the post's client when the task is
  // attached to a post, otherwise the task's own clientId — present whenever
  // the task belongs to a client either way. Mirrors the clientId resolution
  // order used elsewhere (post.clientId, then task.clientId).
  clientName: z.string().optional(),
  post: z
    .object({
      id: z.string(),
      title: z.string(),
      date: z.coerce.date().nullable().optional(),
      clientId: z.string(),
      clientName: z.string().optional(),
      tasks: z.array(agencyTaskSchema).optional(),
    })
    .optional(),
});

export type FilteredUserTaskSchema = z.infer<typeof filteredUserTaskSchema>;
